import { LoaderCircle } from 'lucide-react';
import './LoadingIndicator.css';

interface LoadingIndicatorProps {
  message: string;
  variant?: 'page' | 'section' | 'compact';
  className?: string;
}

const LoadingIndicator = ({
  message,
  variant = 'section',
  className
}: LoadingIndicatorProps) => (
  <div
    className={[
      'app-loading-indicator',
      `app-loading-indicator-${variant}`,
      className
    ].filter(Boolean).join(' ')}
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label={message}
  >
    <span className="app-loading-indicator-icon-wrap" aria-hidden="true">
      <LoaderCircle className="app-loading-indicator-icon" />
    </span>
    <span>{message}</span>
  </div>
);

export default LoadingIndicator;
